import axios, {AxiosError, AxiosPromise, AxiosRequestConfig} from 'axios'
import router from "@/router";
import notifications from "../notifications";

const axiosInstance = axios.create({
  baseURL: (window as any).env.API_URL,
})

// Inject token in request if present
axiosInstance.interceptors.request.use((config: AxiosRequestConfig) => {
  config.headers.Authorization = 'Bearer ' + localStorage.getItem('argo-token')
  return config
})
axiosInstance.interceptors.response.use(
  (response) => {
    return Promise.resolve( response)
  },
  (error) => {
    if(error.response.status == 403) {
     // alert('403! You will now be logged out')
      notifications.notify('error', error.response.status + ' Forbidden. Please Login!')
      localStorage.removeItem('argo-token')
      router.push({name: 'login'})

    }
    return Promise.reject(error)
  }
)
export default {
  getSingle: (resource: string, id: any = null, option: any = null) => {
    switch (resource) {
      case 'reservation':
        return axiosInstance.get(`backoffice/v1/reservation/${id}`)
      case 'reservation_booked_times':
        return axiosInstance.get(`backoffice/v1/reservations/${id}/booked_times`)
      case 'reservation_debug_info':
        return axiosInstance.get(`backoffice/v1/reservation/${id}/debug_info`)
      case 'reservation_route':
        return axiosInstance.get(`backoffice/v1/reservation/${id}/route`)
      case 'vehicle':
        return axiosInstance.get(`backoffice/v1/vehicle/${id}`)
      case 'client':
        return axiosInstance.get(`backoffice/v1/client/${id}`)
      case 'instruction':
        return axiosInstance.get(`backoffice/v1/instructions/${id}`)
      case 'vehicle_attributes':
        return axiosInstance.get(`backoffice/v1/vehicle_attributes/${id}`)
      case 'reportings':
        return axiosInstance.get(`backoffice/v1/${resource}/${id}`)
      case 'movements':
        return axiosInstance.get(`/backoffice/v1/vehicle/${id}/movements/${option.itemsPerPage}/${option.page}`)
      default:
        alert(`no ${resource} can be handled`)
        break;
    }
  },
  postSingle: (resource: string, id: any = null, data: any = null, option: any = null ) => {
    switch (resource) {
      //v1
      case 'availability':
        return axiosInstance.post(`backoffice/v1/vehicle/${id}/${resource}`, data)
      case 'reportings':
        return axiosInstance.post(`backoffice/v1/${resource}/${option.itemsPerPage}/${option.page}`, data)
      //v2
      case 'add_cost':
        return axiosInstance.post(`backoffice/v2/vehicles/${id}/${resource}`, data)
      default:
        alert(`no get ${resource} can be handled`)
        break;
    }
  },
  get: (resource: string, option: any = null) => {
    switch (resource) {
      case 'cards':
        return axiosInstance.post(`backoffice/v1/cards/search?per_page=25&page_number=1`)
      case 'zones':
        return axiosInstance.get(`backoffice/v1/zone`)
      case 'reporting-types':
        return axiosInstance.post(`backoffice/v1/reportings/types`)
      case 'alarms':
        return axiosInstance.get(`backoffice/v2/vehicle_alarms?per_page=25&page_number=1`)
      case 'rates':
        return axiosInstance.get(`backoffice/v2/reservation_rates`)
      case 'asset_costs/types':
        return axiosInstance.get(`backoffice/v2/${resource}`)
      // Standard v1
      case 'vehicle_categories':
      case 'vehicle_types':
      case 'parking_groups':
        return axiosInstance.get(`backoffice/v1/${resource}`)
      case 'invoices':
      case 'transactions':
      case 'reportings':
      case 'vehicles':
      case 'reservations':
      case 'clients':
      case 'drivers':
      case 'subscriptions':
        return axiosInstance.post(`backoffice/v1/${resource}/${option.itemsPerPage}/${option.page}`)
      case 'client_types':
        return axiosInstance.get(`backoffice/v1/${resource}/${option.itemsPerPage}/${option.page}`)
      case 'select/vehicle_categories':
      case 'select/vehicle_brands':
      case 'select/vehicles':
      case 'select/drivers':
      case 'select/reporting_types':
        return axiosInstance.get(`backoffice/v1/${resource}`)

      // Standard V2
      case 'notes':
      case 'vehicle_attributes':
      case 'instructions':
      case 'plans':
      case 'tocs':
      case 'toc_types':
      case 'document_types':
      case 'document_requirements':
        return axiosInstance.get(`backoffice/v2/${resource}`)
      case 'managers':
        return axiosInstance.get(`backoffice/v2/vehicle_hardwares/${resource}`)
      case 'galleryList':
        return axiosInstance.get(`backoffice/v2/files/index_public?prefix=${option}`)
      default:
        alert(`no get ${resource} can be handled`)
        break;
    }
  },
  post: (resource: string, data: any = null) => {
    switch (resource) {
      // v1
      case 'vehicle':
      case 'vehicle_category':
      case 'vehicle_type':
        return axiosInstance.post(`backoffice/v1/${resource}/add`, data)
      case 'login':
        return axiosInstance.post(`backoffice/v1/${resource}`, data)
      // v2
      case 'parking_lot':
        return axiosInstance.post(`backoffice/v2/parking_lots`, data)
      case 'note':
        return axiosInstance.post(`backoffice/v2/notes`, data)
      case 'vehicle_attribute':
        return axiosInstance.post(`backoffice/v2/vehicle_attributes/`, data)

      default:
        alert(`no post ${resource} can be handled`)
        break;
    }
  },
  delete: (resource: string, id: any = null) => {
    switch (resource) {
      // v1
      case 'vehicle_category':
        return axiosInstance.delete(`backoffice/v1/vehicle_category/${id}`)
      //v2
      case 'parking_lot':
        return axiosInstance.delete(`backoffice/v2/parking_lots/${id}`)
      case 'note':
        return axiosInstance.delete(`backoffice/v2/notes/${id}`)
      case 'vehicle_attribute':
        return axiosInstance.delete(`backoffice/v2/vehicle_attributes/${id}`)
      case 'galleryPicture':
        return axiosInstance.delete(`backoffice/v2/files?path=${id}`)
      default:
        alert(`no delete ${resource} can be handled`)
        break;
    }
  },
  update: (resource: string, id: any = null, data: any = null) => {
    switch (resource) {
      // v1
      case 'vehicle':
        return axiosInstance.put(`backoffice/v1/vehicle/${id}/edit`, data)
      case 'vehicle_category':
        return axiosInstance.patch(`backoffice/v1/vehicle_category/${id}/edit`, data)
      // v2
      case 'parking_lot':
        return axiosInstance.post(`backoffice/v2/parking_lots/${id}`, data)
      case 'vehicle_attribute':
        return axiosInstance.patch(`backoffice/v2/vehicle_attributes/${id}`, data)

      default:
        alert(`no update ${resource} can be handled`)
        break;
    }
  },
  upload: (resource: string, data: any) => {
    switch (resource) {
      // v2
      case 'image':
        return axiosInstance.post(`backoffice/v2/files/upload`, data,{
          headers: {
            'Content-Type': 'multipart/form-data',
          }
        })

      default:
        alert(`no upload ${resource} can be handled`)
        break;
    }
  }
}
